export const siteOrderIdRegExp = /^[a-zA-Z]{2,4}[-][a-zA-Z0-9-:s]+$/;
export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Zs]+$/;
export const phoneRegExp = /^\d*$/;
